import { SetMetadata } from '@nestjs/common';

export const AUDIT_ENTITY_KEY = 'audit_entity';

/**
 * Decorador para marcar un endpoint como auditable.
 * @param entityType - Tipo de entidad que se audita (ej: 'suscripcion', 'comprobante', 'plan')
 */
export const Auditable = (entityType: string) => SetMetadata(AUDIT_ENTITY_KEY, entityType);
